/**
 * Backend Realtime API 엔드포인트
 */

// 백엔드 호스트 (WebSocket 전용)
// Cloudflare Tunnel이 Frontend와 Backend를 분리하므로 직접 Backend 도메인 사용
const getBackendHost = (): string => {
  // 환경변수 우선: docker-compose에서 설정한 NEXT_PUBLIC_API_URL 사용
  const apiUrl = process.env.NEXT_PUBLIC_API_URL;
  if (apiUrl) {
    try {
      const url = new URL(apiUrl);
      return url.host;
    } catch {
      // invalid URL, fall through
    }
  }

  if (typeof window === 'undefined') return 'localhost:8600';

  // 프로덕션: agentbuilder.nova.ggls.dev → agentbuilder-backend.nova.ggls.dev
  // Cloudflare Tunnel이 Frontend(3000)와 Backend(8500)를 분리하므로 직접 Backend 도메인 사용
  const hostname = window.location.hostname;
  if (hostname.includes('agentbuilder') && hostname.includes('nova.ggls.dev')) {
    if (hostname.startsWith('agentbuilder-staging')) {
      return 'agentbuilder-staging-backend.nova.ggls.dev';
    }
    return 'agentbuilder-backend.nova.ggls.dev';
  }

  // kikiz.ai 도메인 (agentbuilder.nova.ggls.dev의 AWS Amplify 별칭)
  if (hostname === 'kikiz.ai' || hostname.endsWith('.kikiz.ai')) {
    return 'agentbuilder-backend.nova.ggls.dev';
  }

  // 로컬 개발 환경 기본값
  if (hostname === 'localhost') {
    return 'localhost:8600';
  }

  return window.location.host;
};

// WebSocket 엔드포인트 (브라우저에서 직접 접근)
// provider에 따라 다른 엔드포인트 사용:
// - 'openai' 또는 undefined: /api/realtime/ws (OpenAI Realtime API)
// - 'google': /api/gemini/ws (Gemini Live API)
export const getRealtimeWsUrl = (
  agentId: string,
  avatarId: string,
  sessionId: string,
  enableWebSearch: boolean = false,
  token?: string,
  provider?: 'openai' | 'google' | 'none'
): string => {
  const protocol = typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const host = getBackendHost();

  const params = new URLSearchParams({
    avatar_id: avatarId,
    session_id: sessionId,
    enable_web_search: String(enableWebSearch),
  });

  // 인증 토큰 추가
  if (token) {
    params.set('token', token);
  }

  // provider에 따라 엔드포인트 선택
  const endpoint = provider === 'google' ? '/api/gemini/ws' : '/api/realtime/ws';

  return `${protocol}//${host}${endpoint}/${agentId}?${params.toString()}`;
};

// REST API 엔드포인트
export const REALTIME_API_BASE = '/api/realtime';

export const getSessionInfoUrl = (sessionId: string): string =>
  `${REALTIME_API_BASE}/${sessionId}`;

export const getSearchModeUrl = (sessionId: string): string =>
  `${REALTIME_API_BASE}/${sessionId}/search`;
